import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LoadingButton from '@mui/lab/LoadingButton';

const DeleteAttendeeDialog = ({ open, attendee, deleting = false, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={deleting ? undefined : onClose}
    PaperProps={{
      sx: {
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
      },
    }}
  >
    <DialogContent sx={{ pb: 1, pt: 1 }}>
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          bgcolor: '#fdecea',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <DeleteOutlineIcon sx={{ fontSize: 32, color: '#d32f2f' }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Remove attendee?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        Remove{' '}
        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {attendee?.name ?? 'this attendee'}
        </Box>{' '}
        from the guest list? This action cannot be undone.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
      <Button
        variant="outlined"
        onClick={onClose}
        disabled={deleting}
        sx={{ minWidth: 100, textTransform: 'none' }}
      >
        Cancel
      </Button>
      <LoadingButton
        variant="contained"
        loading={deleting}
        onClick={onConfirm}
        sx={{
          minWidth: 100,
          textTransform: 'none',
          bgcolor: '#d32f2f',
          boxShadow: 'none',
          '&:hover': { bgcolor: 'error.dark', boxShadow: 'none' },
        }}
      >
        Delete
      </LoadingButton>
    </DialogActions>
  </Dialog>
);

export default DeleteAttendeeDialog;
